/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable lodash/prefer-constant */

import React, { createContext, useContext } from 'react';
import type { RemoteModuleRegistry, Events } from '@dutchiesdk/ecommerce-extensions-sdk';

type FallbackProps = { fallback?: (props?: any) => JSX.Element | null };
type DefaultComponentSig = (args0?: FallbackProps) => React.ElementType;

export type RouteablePage = {
  path: string;
  component: DefaultComponentSig;
};

export type CommerceComponents = {
  components: {
    [K in keyof Omit<
      RemoteModuleRegistry,
      'events' | 'getStoreFrontMetaFields' | 'RouteablePages' | 'StoreFrontCarouselInterstitials'
    >]-?: DefaultComponentSig;
  };
  findPage: (o: { fallback?: React.FC; path?: string }) => React.FC;
  iterables: {
    StoreFrontCarouselInterstitials: () => React.ElementType[];
  };
  pages: ({ fallback }: FallbackProps) => RouteablePage[];
  events: Events | undefined;
};

export const defaultCommerceComponents: CommerceComponents = {
  components: {
    StoreFrontHeader: ({ fallback = () => <></> }: FallbackProps) => fallback,
    StoreFrontMeta: ({ fallback = () => <></> }: FallbackProps) => fallback,
    StoreFrontNavigation: ({ fallback = () => <></> }: FallbackProps) => fallback,
    StoreFrontFooter: ({ fallback = () => <></> }: FallbackProps) => fallback,
    StoreFrontHero: ({ fallback = () => <></> }: FallbackProps) => fallback,
    ProductDetailsPrimary: ({ fallback = () => <></> }: FallbackProps) => fallback,
    ProductDetailsMeta: ({ fallback = () => <></> }: FallbackProps) => fallback,
  },
  findPage: ({ fallback = () => <></> }) => fallback,
  iterables: {
    StoreFrontCarouselInterstitials: () => [],
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  pages: (_props: FallbackProps = { fallback: () => <></> }) => [],
  events: {},
};

export const CommerceComponentsContext = createContext<CommerceComponents>(defaultCommerceComponents);

export const useCommerceComponents = (): CommerceComponents => useContext(CommerceComponentsContext);
